// Configuration API
const config = {
  API_URL: process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://app.kokpit.io'  // Forcer l'utilisation de app.kokpit.io en production
      : 'http://localhost:8080'),
  IS_LOCAL: process.env.NODE_ENV !== 'production'
};

export default config;